import React from "react";
import PropTypes from "prop-types";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import Switch from "Common/Custom/Switch";

const AddLaundryTaskForm = ({
  values,
  errors,
  handleChange,
  handleSubmit,
  loading,
  fields,
}) => {

  return (
    <PageBody
      onSubmit={handleSubmit}
      headerchildren={<HeadingOne>Create Laundry Task</HeadingOne>}
    >
      {fields.map((field) => {

        // 🔹 Switch
        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              field={field}
              values={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        // 🔹 Default Text Input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Create"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

AddLaundryTaskForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

AddLaundryTaskForm.defaultProps = {
  errors: {},
  loading: false,
};

export default AddLaundryTaskForm;
